<!--
  - crawler.vue
  - @author Martin Appelmann <martin@movearound.fit>
  - @copyright 2022 movearound GmbH
  -->

<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-8 grid-margin">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <div class="form-group my-2">
                                    <label for="city">Stadt</label>
                                    <input
                                        id="city"
                                        v-model="city"
                                        class="form-control"
                                        placeholder="Stadt eintragen"
                                        required
                                    />
                                    <small class="text-danger">
                                        {{ msgCity }}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="form-group my-2">
                                    <label for="radius">Umkreis: {{ radius }}km</label>
                                    <input
                                        id="radius"
                                        class="form-control-range"
                                        v-model="radius"
                                        type="range"
                                        min="1"
                                        max="50"
                                        step="1"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group my-2">
                                    <label for="type">Type</label>
                                    <input
                                        id="type"
                                        v-model="type"
                                        class="form-control"
                                        placeholder="Type eintragen"
                                        required
                                    />
                                    <small class="text-danger">
                                        {{ msgCity }}
                                    </small>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group my-2">
                                    <label for="type">Keyword</label>
                                    <input
                                        id="keyword"
                                        v-model="keyword"
                                        class="form-control"
                                        placeholder="Keyword eintragen"
                                        required
                                    />
                                    <small class="text-danger">
                                        {{ msgCity }}
                                    </small>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="row">
                            <div class="col">
                                <p>Moin Roman.</p>
                                <p>
                                    Was wir nutzen sind daten von der Google Place Search API.
                                    Google begrenzt die Liste immer auf 60 Einträge.
                                </p>
                                <p>
                                    Beim Eingabefeld 'type' funkioniert 'gym' am besten. Unter 'point_of_interest' hab
                                    ich
                                    die Boulderhallen gefunden.
                                    Probier da mal nen bisschen rum. Der Crawler wird ja stetig verbessert. Also
                                    Feedback
                                    gern an mich. :)
                                </p>
                                <p>
                                    <a target="_blank"
                                       href="https://developers.google.com/maps/documentation/places/web-service/supported_types">Hier</a>
                                    gibt es einige Types aufgelistet. Falls du mal durchgucken willst was es da so alles
                                    gibt.
                                </p>
                                <p>
                                    Keyword ist optional.
                                    Da kannst du die Suche begrenzen. Also z.B. kannst du 'Yoga' eintragen um nach Yoga
                                    Studios zu suchen.
                                </p>
                                <p>
                                    Unter Anzeigen findest du dann nähere Infos. Man bekommt sogar die Öffnungszeiten
                                    und
                                    die
                                    Google Bewertungen.
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <button
                                    v-on:click="search"
                                    :disabled="loading"
                                    class="btn btn-primary"
                                >
                                     <span class="spinner-border spinner-border-sm" v-if="loading" role="status"
                                           aria-hidden="true"></span>
                                    Search
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row" v-if="result">
            <div class="col">
                <div class="card">
                    <div class="card-body">

                        <button class="btn btn-info btn-sm m-1" @click="selectAllRows">Alle Auswählen</button>
                        <button class="btn btn-info btn-sm m-1" @click="clearSelected">Auswahl löschen</button>
                        <button
                            class="btn btn-info btn-sm m-1"
                            @click="exportHubspot"
                            :disabled="loadingExport || selected.length === 0"
                        >
                            <span class="spinner-border spinner-border-sm" v-if="loadingExport" role="status"
                                  aria-hidden="true"></span>
                            Auswahl nach Hubspot exportieren
                        </button>
                        <button
                            class="btn btn-info btn-sm m-1"
                            @click="exportExcel"
                            :disabled="loadingExport || selected.length === 0"
                        >
                            <span class="spinner-border spinner-border-sm" v-if="loadingExport" role="status"
                                  aria-hidden="true"></span>
                            Auswahl als Excel exportieren
                        </button>

                        <table id="tableComponent" class="table table-responsive">
                            <thead>
                                <tr>
                                    <th v-for="field in fields">{{ field.label }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(item, index) in result"
                                    :key='item' v-on:click="onRowSelected(item,index)"
                                    :class="{'bg-light': isSelected(item)}"
                                >
                                    <td>
                                        <div v-if="isSelected(item)">
                                            <span aria-hidden="true">&check;</span>
                                            <span class="sr-only">Selected</span>
                                        </div>
                                        <div v-else>
                                            <span aria-hidden="true">&nbsp;</span>
                                            <span class="sr-only">Not selected</span>
                                        </div>
                                    </td>
                                    <td>
                                        <a target="_blank" :href="'crawler/place?place_id='+ item.place_id">Anzeigen</a>
                                    </td>
                                    <td>{{ item.name }}</td>
                                    <td>{{ item.business_status }}</td>
                                    <td>{{ item.rating }}</td>
                                    <td>{{ item.user_ratings_total }}</td>
                                    <td>{{ item.vicinity }}</td>
                                    <td>
                                        <div v-for="type in item.types" class="badge mr-1 badge-pill badge-primary">
                                            {{ type }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

export default {
    name: 'crawler',
    data: function () {
        return {
            city: '',
            radius: 30,
            type: '',
            keyword: '',
            result: null,
            loading: false,
            errorCity: null,
            msgCity: '',
            errorType: null,
            msgType: '',
            errorKeyword: null,
            msgKeyword: '',
            errorRadius: null,
            msgRadius: '',
            fields: [
                {
                    key: 'selected',
                    label: ''
                },
                {
                    key: 'place_id',
                    label: ''
                },
                {
                    key: 'name',
                    label: 'Name'
                },
                {
                    key: 'business_status',
                    label: 'Business Status'
                },
                {
                    key: 'rating',
                    label: 'Rating'
                },
                {
                    key: 'user_ratings_total',
                    label: 'Ratings Gesamt',
                    sortable: true
                },
                {
                    key: 'vicinity',
                    label: 'Adresse'
                },
                {
                    key: 'types',
                    label: 'Typen',
                    sortable: true
                }
            ],
            selected: [],
            loadingExport: false,
        }
    },
    methods: {
        onRowSelected (item, index) {
            if (this.isSelected(item)) {
                this.selected.splice(this.selected.indexOf(item), 1)
            } else {
                this.selected.push(item)
            }
        },
        selectAllRows () {
            this.selected = this.result
        },
        clearSelected () {
            this.selected = []
        },
        isSelected (item) {
            return this.selected.includes(item)
        },
        exportHubspot () {
            this.loadingExport = true
            axios.post('api/crawler/hubspot/export', {
                selected: this.selected
            }).then((response) => {
                this.loadingExport = false
                this.clearSelected()
            }, (error) => {
                this.loadingExport = false
                this.clearSelected()
            })
        },
        exportExcel () {
            axios.post('api/crawler/excel/export',
                { results: this.selected },
                { responseType: 'blob' }
            ).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]))
                var fileLink = document.createElement('a')
                fileLink.href = fileURL
                fileLink.setAttribute('download', 'crawler_ergebnis.xlsx')
                document.body.appendChild(fileLink)
                fileLink.click()
                this.loadingExport = false
                this.clearSelected()
            }, (error) => {
                this.loadingExport = false
                this.clearSelected()
            })
        },
        search () {
            this.loading = true
            axios.get('api/crawler/search', {
                params: {
                    city: this.city,
                    radius: this.radius,
                    type: this.type,
                    keyword: this.keyword
                }
            }).then((response) => {
                this.loading = false
                this.errorCity = null
                this.errorType = null
                this.errorRadius = null
                this.errorKeyword = null
                this.result = response.data
            }, (error) => {
                this.loading = false
                if (error.response.status === 422) {
                    if (error.response.data.errors.city != null) {
                        this.errorCity = false
                        this.msgCity = error.response.data.errors.city[0]
                    }
                    if (error.response.data.errors.type != null) {
                        this.errorType = false
                        this.msgType = error.response.data.errors.type[0]
                    }
                    if (error.response.data.errors.radius != null) {
                        this.errorRadius = false
                        this.msgRadius = error.response.data.errors.radius[0]
                    }
                    if (error.response.data.errors.keyword != null) {
                        this.errorKeyword = false
                        this.msgKeyword = error.response.data.errors.keyword[0]
                    }
                }
            })
        }
    }
}
</script>

